<div class="card options-card">
  <div class="card-header bp-card-header">
    <i class="fas fa-wallet payment-options-icon"></i>
    <p class="font-weight-light bp-text">Manage Payment Methods</p>
  </div>
  <div class="card-body">


        <button class="btn btn-link btn-block clearfix accordion-btn" (click)="showManagePayments=!showManagePayments">
          <!--<i *ngIf="!showManagePayments" class="fas fa-angle-right fa-2x accordion-arrow"></i>
          <i *ngIf="showManagePayments" class="fas fa-angle-down fa-2x accordion-arrow"></i>-->
          <div class="accordion-title-div pull-left font-weight-light bp-text bp-medium-text">Add/Edit Bank Accounts for Online Payments</div>
        </button>
        <div class="container accordion-container">
          <div class="row">
            <p class="bp-text bp-small-text tall-p">
              Add a checking or savings account to be used for future online payments. You’ll need your bank name, bank account number and routing number and then you’ll be set for hassle-free payments.
            </p>
          </div>
          <div class="row">
            <h4 class="red-link-header"><a style="width: 32%;" class="bp-link-red float-right">ADD NEW ACCOUNT<i class="fas fa-chevron-right view-more-arrow red-link-arrow"></i></a></h4>
          </div>
          <div class="row">
            <h4 class="red-link-header"><a style="width: 40%;" class="bp-link-red float-right">EDIT CURRENT ACCOUNT<i class="fas fa-chevron-right view-more-arrow red-link-arrow"></i></a></h4>
          </div>
        </div>


        <button class="btn btn-link accordion-btn" (click)="showEnrollment=!showEnrollment">
          <!--<i *ngIf="!showEnrollment" class="fas fa-angle-right fa-2x accordion-arrow"></i>
          <i *ngIf="showEnrollment" class="fas fa-angle-down fa-2x accordion-arrow"></i>-->
          <div class="accordion-title-div pull-left font-weight-light bp-text bp-medium-text">Enroll in Auto Pay</div>
        </button>
        <div class="container accordion-container">
          <div class="row">
            <p class="bp-text bp-small-text tall-p">
              Auto Pay is a payment program where you can authorize your bill amount to be automatically debited from your checking or
              savings account. There is no fee for this service. You will continue to receive your monthly bill.
            </p>
          </div>
          <div class="row">
            <h4 class="red-link-header"><a style="width: 15%;" class="bp-link-red float-right">SIGN UP<i class="fas fa-chevron-right view-more-arrow red-link-arrow"></i></a></h4>
          </div>
        </div>


  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/manage-payments/manage-payments.component.html